import {
  deletePoll,
  savePoll,
  updateActionsPoll,
  updatePoll,
} from "actions/WorkFlowActions";
import Loader from "components/UI/Loader";
import React, { useEffect, useState } from "react";
import { IoCloseCircleOutline } from "react-icons/io5";
import { MdDelete, MdSave } from "react-icons/md";
import { notify } from "utils";
import ProbeList from "../DrangAndDrop/ProbesList";
import EmptyData from "assets/animations/empty-data.json";
import Lottie from "lottie-react";

const ModalHeader = ({ title, onClose, isLoading }) => (
  <div className="h-20 w-full flex flex-row justify-between items-center px-5 bg-black rounded-t-lg">
    <span className="text-white font-[Gravity] text-2xl font-bold">
      {title}
    </span>
    {isLoading ? (
      <div className="pt-2">
        <svg
          class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      </div>
    ) : (
      <IoCloseCircleOutline
        onClick={onClose}
        className="text-white text-4xl cursor-pointer"
      />
    )}
  </div>
);

const NewPollForm = ({ form, setForm, onSave, order, handleReset, isIncident }) => (
  <div className="h-14 w-full flex flex-row items-center bg-[#cecece] rounded-lg px-5 mb-2">
    <div className="w-2/12 flex justify-center pl-7">
      <div className="h-10 w-10 bg-[#e5e5e5] text-[#757575] rounded-lg flex items-center justify-center font-bold">
        {order}
      </div>
    </div>
    <div className="w-8/6 lg:w-7/12">
      <input
        value={form.name}
        onChange={({ target }) =>
          setForm((prev) => ({ ...prev, name: target.value }))
        }
        maxLength={50}
        type="text"
        className="h-10 w-full lg:w-3/5 flex items-center justify-start truncate font-bold bg-[#e5e5e5] text-[#757575] rounded-lg px-3"
      />
    </div>
    <div className="w-1/6 lg:w-3/12 flex flex-row space-x-4 text-white ">
      <div className="flex flex-col">
        <label htmlFor="required">Obligatorio</label>
        <input
          type="radio"
          id="required"
          name="option-radio"
          checked={form.required === true}
          onClick={() => {
            setForm({ ...form, required: !form.required });
          }}
        />
      </div>
      <div className="flex flex-col">
        <label htmlFor="required">Trackeo GPS</label>
        <input
          type="radio"
          id="isCheking"
          name="option-isCheking"
          checked={form.isCheking === true}
          onClick={() => {
            setForm({ ...form, isCheking: !form.isCheking });
          }}
          disabled={isIncident}
        />
      </div>
    </div>
    <div className="w-1/5 lg:w-1/12 flex justify-end gap-3">
      <div
        onClick={onSave}
        className="h-10 w-10 flex justify-center items-center rounded-full bg-[#77ace9] text-[#757575] cursor-pointer hover:text-white"
      >
        <MdSave />
      </div>
      <div
        onClick={() => handleReset()}
        className="h-10 w-10 flex justify-center items-center rounded-full bg-[#ababab] text-white cursor-pointer hover:text-black"
      >
        <MdDelete />
      </div>
    </div>
  </div>
);

const ModalBody = ({ polls, idStage, onClose, nameStage, isIncident }) => {
  const [localPolls, setLocalPolls] = useState([]);
  const [form, setForm] = useState({
    name: "",
    required: false,
    isCheking: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isNewPoll, setIsNewPoll] = useState(false);

  useEffect(() => {
    setLocalPolls(polls);
  }, [polls]);

  const handleSavePoll = async () => {
    if (!form.name.trim())
      return notify("warning", "Nombre es requerido", 3000);
    if (
      localPolls.some(
        (item) =>
          item.name.trim().toLowerCase() === form.name.trim().toLowerCase()
      )
    )
      return notify("warning", "El sondeo ya existe", 3000);

    const data = {
      name: form.name,
      required: form.required,
      isCheking: form.isCheking,
      idStage,
      order: localPolls.length + 1,
    };

    setIsLoading(true);
    try {
      const response = await savePoll(data);
      if (response) {
        setLocalPolls((prev) => [...prev, response]);
        handleReset();
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeletePoll = async (id) => {
    setIsLoading(true);
    try {
      const response = await deletePoll(id);
      if (response) {
        setLocalPolls((prev) => prev.filter((poll) => poll.id !== id));
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdatePoll = async (data, idPoll) => {
    const nameExists = localPolls.some(
      (poll) =>
        poll.id !== idPoll &&
        poll.name.trim().toLowerCase() === data.name.trim().toLowerCase()
    );
    if (nameExists) {
      notify("warning", "El sondeo ya existe", 3000);
      return;
    }

    setIsLoading(true);
    try {
      const response = await updatePoll(data, idPoll);
      if (response) {
        setLocalPolls((prev) =>
          prev.map((poll) => ({
            ...poll,
            required: poll.id === idPoll ? data.required : poll.required,
            isCheking: poll.id === idPoll ? data.isCheking : poll.isCheking,
            name: poll.id === idPoll ? data.name : poll.name,
          }))
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleReset = () => {
    setForm({ name: "", required: false, isCheking: false });
    setIsNewPoll(false);
  };

  const handleChangeOrder = async (aPolls) => {
    if (isNewPoll)
      return notify("warning", "Hay un sondeo pendiente por guardar", 3000);
    const actions = {
      Add: [],
      Delete: [],
      Update: aPolls,
    };
    setIsLoading(true);
    try {
      const response = await updateActionsPoll(actions);
      if (response) {
        setLocalPolls(aPolls);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <ModalHeader
        title={`Editar Sondeos - ${nameStage}`}
        onClose={onClose}
        isLoading={isLoading}
      />
      <div className="h-auto flex flex-row justify-center lg:justify-end  mt-5 mr-5">
        <div
          onClick={() => {
            if (isIncident && localPolls.length >= 1)
              return notify(
                "warning",
                "Solo se puede hacer un sondeo en las etapas que son del tipo incidencia",
                3000
              );
            setIsNewPoll(true);
          }}
          className="h-10 w-32 flex items-center justify-center text-white rounded-lg bg-black cursor-pointer hover:shadow-md hover:bg-[#EBC533]"
        >
          Agregar
        </div>
      </div>
      {isLoading ? (
        <Loader />
      ) : localPolls.length === 0 && isNewPoll === false ? (
        <div className="w-full h-96 mt-5 flex justify-center items-center">
          <Lottie
            animationData={EmptyData}
            loop={true}
            autoplay={true}
            className="w-96 h-96"
          />
        </div>
      ) : (
        <div className="lg:px-10 sm:px-0">
          <div className="h-auto w-full flex flex-row text-gray-700 font-semibold gap-3">
            <div className="w-2/12 ml-7 text-center">Orden</div>
            <div>Nombre</div>
          </div>
          <div className="max-h-96 min-h-40 w-full overflow-auto">
            <ProbeList
              handleDelete={handleDeletePoll}
              handleUpdate={handleUpdatePoll}
              localProbes={localPolls}
              handleChangeOrder={handleChangeOrder}
              isNewPoll={isNewPoll}
              isIncident={isIncident}
            />
            {isNewPoll && (
              <NewPollForm
                form={form}
                setForm={setForm}
                onSave={handleSavePoll}
                order={localPolls.length + 1}
                handleReset={handleReset}
                isIncident={isIncident}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

const ModalEditProbes = ({
  isOpen,
  onClose,
  nameStage,
  polls,
  idStage,
  isIncident,
}) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setShowModal(true), 10);
    } else {
      setShowModal(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div
        className={`bg-white rounded-xl shadow-lg w-full max-w-7xl h-[60vh] relative transition-all duration-300 transform ${
          showModal ? "scale-100 opacity-100" : "scale-95 opacity-0"
        }`}
      >
        <div className="h-full overflow-y-auto">
          <ModalBody
            onClose={onClose}
            nameStage={nameStage}
            polls={polls}
            idStage={idStage}
            isIncident={isIncident}
          />
        </div>
      </div>
    </div>
  );
};

export default ModalEditProbes;
